<div class="container-fluid">
    <div class="table-title">
        <h2>
            Listado de Facturas
        </h2>
        <p class="subtitle">Consulta, edita o gestiona tus facturas desde esta tabla</p>
    </div>
    <div class="mt-4 px-4">
        <ng-template #expandTemplate let-row>
            <h6 class="mb-3 text-secondary">Detalle de {{ row.number }}</h6>
            <div class="table-responsive">
                <table mat-table class="table table-striped table-bordered mat-elevation-z8 toplineBlue">
                    <thead class="table-secondary">
                        <tr mat-header-row>
                            <th mat-header-cell>Concepto</th>
                            <th mat-header-cell class="text-end">Cantidad</th>
                            <th mat-header-cell class="text-end">Precio</th>
                            <th mat-header-cell class="text-end">Descuento</th>
                            <th mat-header-cell class="text-end">Impuestos</th>
                            <th mat-header-cell class="text-end">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let line of row.lines; trackBy: trackByIndex">
                            <td>{{ line.product }}</td>
                            <td class="text-end">{{ line.quantity }}</td>
                            <td class="text-end">{{ line.price | number:'1.2-2' }} €</td>
                            <td class="text-end">{{ line.discount }} %</td>
                            <td class="text-end">{{ line.taxes }}</td>
                            <td class="text-end">{{ (line.price * 1.21 * line.quantity) | number:'1.2-2' }} €</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>

        <ng-template #invoiceSummary let-data="data">
            <div class="d-flex justify-content-between align-items-center">
                <div><strong>Total facturado:</strong> {{ 1250 | number: '1.2-2' }} €</div>
                <div><strong>Total IVA (21%):</strong> {{ 1500 * 0.21 | number: '1.2-2' }} €</div>
            </div>
        </ng-template>


        <app-custom-table [config]="tableConfig" ></app-custom-table>
    </div>
</div>
<!-- 


<form *ngIf="form" [formGroup]="form">

    <div class="container-fluid mt-4 px-4">
        <div class="card shadow-sm">
            <div class="card-body p-4">
                <h5 class="card-title mb-4">Nuevo contacto</h5>

                <div class="row">
                    <div class="col-md-4 col-lg-3 col-xs-12">
                        <app-input [formControl]="form.get('companyName')"
                            [config]="formConfiguration.companyName"></app-input>
                    </div>
                    <div class="col-md-4 col-lg-3 col-xs-12">
                        <app-input [formControl]="form.get('vatNumber')"
                            [config]="formConfiguration.vatNumber"></app-input>
                    </div>
                </div>

                <hr style="border: none; border-top: 1px solid #ccc; margin: 2rem 0;" />

                <div class="row">
                    <div class="col-md-2 col-sm-12 mb-3">
                        <div class="nav flex-column nav-pills" role="tablist">
                            <a class="nav-link py-1 px-2 small" [class.disabled]="!form.get('isClient')?.value"
                                [attr.aria-disabled]="!form.get('isClient')?.value"
                                [ngClass]="{ 'active': activeTab === 'client' }"
                                (click)="onTabClick('isClient','client')">
                                Cliente
                                <span (click)="$event.stopPropagation()">
                                    <app-checkbox [formControl]="form.get('isClient')"
                                        [config]="formConfiguration.isClient"
                                        style="display: inline; float: right;"></app-checkbox>
                                </span>
                            </a>

                            <a class="nav-link py-1 px-2 small" [class.disabled]="!form.get('isProvider')?.value"
                                [attr.aria-disabled]="!form.get('isProvider')?.value"
                                [ngClass]="{ 'active': activeTab === 'provider' }"
                                (click)="onTabClick('isProvider', 'provider')">
                                Proveedor
                                <span (click)="$event.stopPropagation()">
                                    <app-checkbox [formControl]="form.get('isProvider')"
                                        [config]="formConfiguration.isProvider"
                                        style="display: inline; float: right;"></app-checkbox>
                                </span>
                            </a>

                            <a class="nav-link py-1 px-2 small" [class.disabled]="!form.get('isDebtor')?.value"
                                [attr.aria-disabled]="!form.get('isDebtor')?.value"
                                [ngClass]="{ 'active': activeTab === 'debtor' }"
                                (click)="onTabClick('isDebtor','debtor')">
                                Deudor
                                <span (click)="$event.stopPropagation()">
                                    <app-checkbox [formControl]="form.get('isDebtor')"
                                        [config]="formConfiguration.isDebtor"
                                        style="display: inline; float: right;"></app-checkbox>
                                </span>
                            </a>

                            <a class="nav-link py-1 px-2 small" (click)="onTabClick($event, 'property')">
                                Inmuebles
                            </a>
                        </div>
                    </div>

                    <div class="col-md-10 col-sm-12">
                        <div class="tab-content">
                            <div class="tab-pane fade show active"
                                [ngClass]="{ 'show active': activeTab === 'general' }" id="general">
                                <app-contact-general-form></app-contact-general-form>
                            </div>
                            <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'client' }"
                                id="client">
                                <app-contact-client-form></app-contact-client-form>
                            </div>
                            <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'provider' }"
                                id="provider">
                                <app-contact-provider-form></app-contact-provider-form>
                            </div>
                            <div class="tab-pane fade" [ngClass]="{ 'show active': activeTab === 'debtor' }"
                                id="debtor">
                                <app-contact-debtor-form></app-contact-debtor-form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12">
                        *Es necesario confeccionar los datos basicos para la correcta emision de los impuestos
                    </div>
                </div>
            </div>
        </div>


    </div>
</form> -->